import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LinkButtonComponent } from './buttons/link-button/link-button.component';

@Component({
  selector: 'app-button-add-existing-user',
  template: `
    <app-link-button
      icon="add_icon"
      [text]="'customer-spaces.user-management.add-employee.title' | translate"
      [disabled]="disabled"
      (clicked)="clicked.emit()"
    ></app-link-button>
  `,
  styles: [``],
  standalone: true,
  imports: [TranslateModule, LinkButtonComponent],
})
export class ButtonAddExistingUserComponent {
  @Input() disabled!: boolean;
  @Output() clicked = new EventEmitter();
}
